import * as React from "react";
import { ChevronRight } from "lucide-react";
import { Avatar } from "@/components/ui/avatar";
import { ImpersonatableUsers } from "@/services/bedrock/dtos";
import { useImpersonationDialogContext } from "../ImpersonationContext";

interface UserListItemProps {
  user: ImpersonatableUsers;
  isFocused: boolean;
  isRecent?: boolean;
}

export const UserListItem: React.FC<UserListItemProps> = ({ user, isFocused, isRecent = false }) => {
  const { handleImpersonate, getInitials } = useImpersonationDialogContext();

  const fallbackColorClass = isRecent ? "bg-indigo-50 text-indigo-600" : "bg-slate-100 text-slate-600";

  return (
    <button
      data-focused={isFocused}
      className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all text-left relative group ${
        isFocused ? "bg-primary text-white shadow-md shadow-primary/15" : "hover:bg-slate-100 text-slate-700"
      }`}
      onClick={() => handleImpersonate(user)}
    >
      <Avatar className="h-9 w-9 border border-slate-100 shrink-0 shadow-sm">
        <Avatar.Image src={user.photoUrl} alt={user.fullName || ""} />
        <Avatar.Fallback className={`text-xs font-bold ${isFocused ? "bg-white/10 text-white" : fallbackColorClass}`}>
          {getInitials(user.fullName)}
        </Avatar.Fallback>
      </Avatar>
      <div className="flex-1 min-w-0">
        <div className={`text-sm font-bold truncate ${isFocused ? "text-white" : "text-slate-800"}`}>
          {user.fullName}
        </div>
        <div className={`text-xs truncate ${isFocused ? "text-white/80" : "text-slate-400"}`}>{user.email}</div>
      </div>
      <ChevronRight
        className={`h-4 w-4 shrink-0 transition-transform ${
          isFocused ? "text-white translate-x-0.5" : "text-slate-300 group-hover:text-indigo-500"
        }`}
      />
    </button>
  );
};
